module.exports = __webpack_public_path__ + "images/onboarding-banner/Wave.f91cf741690ff2974ee0.svg";